import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { DocumentStatus } from '../../../../../core';

@JsonConverter
export class DocumentStatusAdapter implements JsonCustomConvert<DocumentStatus | undefined> {
    serialize(status: DocumentStatus): any | undefined {
        return status ? String(status) : undefined;
    }

    deserialize(status: any): DocumentStatus | undefined {
        switch (status) {
            case 'PENDING':
                return DocumentStatus.PENDING;
            case 'VALIDATE':
                return DocumentStatus.VALIDATE;
            case 'RECTIFY':
                return DocumentStatus.RECTIFY;
            default:
                return undefined;
        }
    }
}
